import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';
import { roundSelector, seasonSelector, statsTypeSelector } from '.';

/**
 * Checks whether we have the information necessary to perform the fetch to
 * retrieve the correct stats.
 *
 * @returns {( object ) => { stats: object, details: object}[] | null} The player stats.
 */
export const playerStatsSelector = createSelector(
    statsLeadersSelector,
    statsTypeSelector,
    seasonSelector,
    roundSelector,
    (
        {
            nav,
            keys,
            values
        },
        statsType,
        season,
        round
    ) => {
        if (
            nav.competition.id === null ||
            nav.season.id === null ||
            nav.round.id === null
        ) {
            return null;
        }

        const getStats = ( providerId, keysObj ) => {
            if ( !providerId ) { return null; }
    
            const statsIds = keysObj[ providerId ]?.players;
            if ( !statsIds ) { return null; }

            return statsIds.map( statsId => {
                const stats = values.stats[ statsId ];
                const {
                    totals,
                    averages,
                    benchmarkedTotals,
                    benchmarkedAverages
                } = stats;

                const details = values.players[ stats.playerId ];
                const { givenName, surname, position } = details;
                
                return {
                    stats: {
                        totals,
                        averages,
                        benchmarkedTotals,
                        benchmarkedAverages
                    },
                    details: {
                        playerId: stats.playerId,
                        givenName,
                        surname,
                        position
                    },
                    team: values.teams[ stats.team ]
                };
            } );
        };
    
        switch ( statsType ) {
            case 'seasons':
                return getStats( season?.providerId, keys.seasons );
            case 'rounds':
                return getStats( round?.providerId, keys.rounds );
            default:
                return null;
        }
    }
);